var _defs, _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _ellipse2, _path7, _path8, _path9, _path10, _path11, _circle, _circle2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _ellipse3, _ellipse4, _path20, _path21, _path22;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgParticipants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke-width: 6px;\n      }\n\n      .st0, .st1, .st2 {\n        stroke: #5a4f51;\n        stroke-miterlimit: 10;\n      }\n\n      .st3 {\n        fill: url(#Sfumatura_senza_nome_5);\n      }\n\n      .st4 {\n        fill: url(#Sfumatura_senza_nome_3);\n      }\n\n      .st1 {\n        fill: url(#Sfumatura_senza_nome_8);\n      }\n\n      .st1, .st2 {\n        stroke-width: 5px;\n      }\n\n      .st5 {\n        fill: url(#Sfumatura_senza_nome_2);\n      }\n\n      .st6 {\n        fill: #fcbda7;\n      }\n\n      .st7 {\n        fill: url(#Sfumatura_senza_nome_18);\n      }\n\n      .st8 {\n        fill: url(#Sfumatura_senza_nome_6);\n      }\n\n      .st9 {\n        fill: #5a4f51;\n      }\n\n      .st10 {\n        fill: url(#Sfumatura_senza_nome_20);\n      }\n\n      .st11 {\n        fill: url(#Sfumatura_senza_nome_10);\n      }\n\n      .st12 {\n        fill: url(#Sfumatura_senza_nome_9);\n      }\n\n      .st13 {\n        fill: url(#Sfumatura_senza_nome_11);\n      }\n\n      .st14 {\n        fill: url(#Sfumatura_senza_nome);\n      }\n\n      .st2 {\n        fill: url(#Sfumatura_senza_nome_7);\n      }\n\n      .st15 {\n        fill: url(#Sfumatura_senza_nome_27);\n      }\n\n      .st16 {\n        fill: url(#Sfumatura_senza_nome_4);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome",
    "data-name": "Sfumatura senza nome",
    x1: 377.7,
    y1: 379.3,
    x2: 377.7,
    y2: 234.9,
    gradientTransform: "translate(0 -65.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcab81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcad86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fdbda7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fec8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ffcfcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd1d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_2",
    "data-name": "Sfumatura senza nome 2",
    x1: 433.5,
    y1: -24.4,
    x2: 445.6,
    y2: -24.4,
    gradientTransform: "translate(0 217.5) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fec8be"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_3",
    "data-name": "Sfumatura senza nome 3",
    x1: 308.3,
    y1: -27.1,
    x2: 320.4,
    y2: -27.1,
    gradientTransform: "translate(0 217.5) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fec8be"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_4",
    "data-name": "Sfumatura senza nome 4",
    x1: 114.5,
    y1: 367,
    x2: 114.5,
    y2: 203.8,
    gradientTransform: "translate(0 -65.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcab81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcad86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fdbda7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fec8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ffcfcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd1d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_5",
    "data-name": "Sfumatura senza nome 5",
    x1: 178.1,
    y1: -5.8,
    x2: 191.8,
    y2: -5.8,
    gradientTransform: "translate(0 217.5) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fec8be"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_6",
    "data-name": "Sfumatura senza nome 6",
    x1: 38.4,
    y1: -6,
    x2: 52.1,
    y2: -6,
    gradientTransform: "translate(0 217.5) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fec8be"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Sfumatura_senza_nome_7",
    "data-name": "Sfumatura senza nome 7",
    cx: 90.2,
    cy: 293.4,
    fx: 90.2,
    fy: 293.4,
    r: 20.7,
    gradientTransform: "translate(0 -65.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Sfumatura_senza_nome_8",
    "data-name": "Sfumatura senza nome 8",
    cx: 144.5,
    cy: -6.6,
    fx: 144.5,
    fy: -6.6,
    r: 20.7,
    gradientTransform: "translate(0 217.5) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_9",
    "data-name": "Sfumatura senza nome 9",
    x1: 332.2,
    y1: 47.6,
    x2: 349.6,
    y2: 47.6,
    gradientTransform: "translate(0 217.5) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fec8be"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_10",
    "data-name": "Sfumatura senza nome 10",
    x1: 251.1,
    y1: 338.1,
    x2: 251.1,
    y2: 129.7,
    gradientTransform: "translate(0 -65.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcab81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcad86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fdbda7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fec8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ffcfcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd1d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_11",
    "data-name": "Sfumatura senza nome 11",
    x1: 153.1,
    y1: 46.9,
    x2: 170.4,
    y2: 46.9,
    gradientTransform: "translate(0 217.5) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fec8be"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_27",
    "data-name": "Sfumatura senza nome 27",
    x1: 267,
    y1: 386.4,
    x2: 500,
    y2: 386.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#54bae2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#53b5df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#50a7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#4d91ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4772b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4356a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_20",
    "data-name": "Sfumatura senza nome 20",
    x1: 0,
    y1: 391.5,
    x2: 128.3,
    y2: 391.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#19233e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#202941"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#333a4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54565b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_18",
    "data-name": "Sfumatura senza nome 18",
    x1: 81.7,
    y1: 124,
    x2: 428.2,
    y2: 124,
    gradientTransform: "translate(0 499.5) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#79b38c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbd143"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M311,241.5s-8.6,24.2,0,39.2c8.6,15.1-8.6,24.7-9.1,43.9s7.1,25.3,19.8,28.4c12.7,3.1,116.3,19.8,126.8,0s4.2-32.4,0-52.7c-4.2-20.3,10.5-16.7,11.4-45.6s-11.2-20.8-18.2-32.9c-7-12.2-119.5-3.8-119.5-3.8l-11.2,23.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M401,321.4v-40.7h-43v40.7c-110.6,48.3-97.8,85.1-97.8,85.1h238.5c.1,0,13-36.9-97.7-85.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M435.3,241.5c0,21.8-8.2,46.4-26.5,60.8-4.1,3.1-15.7,12-31.1,11.4-28.2-1.1-57.6-33.6-57.6-72.2s25.8-72.2,57.6-72.2,57.6,32.3,57.6,72.2h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M445.6,241.9c0,4.1-.9,8.8-2.8,11.5-.4.6-1.6,2.3-3.3,2.2-2.9-.2-6-6.4-6-13.7s2.7-13.7,6-13.7c3.4-.1,6.1,6.2,6.1,13.7h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M356.1,195.5s50.1,40,83,32.6-29.5-80.6-65.1-74.9-73,43.7-63,88.2c0,.1,39.1-39,45.1-45.9Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 405,
    cy: 241.5,
    rx: 2.6,
    ry: 5.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M320.4,244.6c0,4.1-.9,8.8-2.8,11.5-.4.6-1.6,2.3-3.3,2.2-2.9-.2-6-6.4-6-13.7s2.7-13.7,6-13.7,6.1,6.2,6.1,13.7h0Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 351.4,
    cy: 241.6,
    rx: 2.6,
    ry: 5.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M138.5,322.4v-36.1h-40v36.1C-4.2,365.3,7.8,398,7.8,398h221.5s12-32.7-90.8-75.6Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M179.7,219.8c0,24.6-9.2,52.5-30,68.7-4.6,3.6-17.8,13.6-35.2,12.9-31.9-1.2-65.2-38-65.2-81.6s29.2-81.6,65.2-81.6,65.2,36.6,65.2,81.6h0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M133.4,334.7v71.8h69.7s10.5-30.3-69.7-71.8ZM136.8,176.7s-49.2,40-81.5,32.6,29-80.6,63.9-74.9c34.9,5.7,71.7,43.7,61.8,88.2,0,.1-38.2-39-44.2-45.9h0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M191.8,223.2c0,4.7-1,10-3.1,13.1-.5.7-1.8,2.6-3.7,2.5-3.3-.2-6.8-7.2-6.8-15.5s3.1-15.5,6.8-15.5,6.8,6.8,6.8,15.4Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M52.1,223.4c0,4.7-1,10-3.1,13.1-.5.7-1.8,2.6-3.7,2.5-3.3-.2-6.8-7.2-6.8-15.5s3.1-15.5,6.8-15.5,6.8,6.8,6.8,15.4Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 90.2,
    cy: 227.8,
    r: 20.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 144.5,
    cy: 227.4,
    r: 20.7
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.4,213.9l16.8,9.5h3.3M110.8,227.8s5.5-7.2,13-.4M165.1,227.4l15.9-13.5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M176,108.9s-2.2-61.1,53.7-64"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M286.2,287v-56.2h-62.1v56.2c-159.7,66.6-141.1,117.4-141.1,117.4h344.5c-.1,0,18.5-50.7-141.3-117.4Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M349.6,169.9c0,6-1.2,12.7-4,16.7-.6.9-2.3,3.3-4.7,3.1-4.3-.3-8.7-9.2-8.7-19.8s3.9-19.8,8.7-19.8,8.7,8.9,8.7,19.8Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M334.2,168.3c0,31.4-11.7,67-38.2,87.7-5.8,4.5-22.8,17.3-44.9,16.5-40.7-1.6-83.2-48.4-83.2-104.2s37.3-104.2,83.2-104.2,83.1,46.6,83.1,104.2Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M170.4,170.6c0,6-1.2,12.7-4,16.7-.6.9-2.3,3.3-4.7,3.1-4.3-.3-8.7-9.2-8.7-19.8s3.9-19.8,8.7-19.8,8.7,9,8.7,19.8Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M256.9,45.4c-2-.4-4.1-.5-6.1-.4v44.2c28.3-.8,57,7.4,57,7.4,7.5,9.9,27.3,76.3,27.3,76.3,12.5-64.4-34-119.3-78.2-127.5h0Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M245.4,45.4c2-.4,3.9-.5,5.9-.5v44.2c-27.4-.8-55.2,7.4-55.2,7.4-7.3,9.9-26.4,76.3-26.4,76.3-12.1-64.3,32.9-119.2,75.7-127.4h0Z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 288.3,
    cy: 162,
    rx: 5.2,
    ry: 10.4
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 217.7,
    cy: 161.3,
    rx: 5.2,
    ry: 10.4
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M499.9,404.4c.7-8.3-1.8-39.3-69.7-79.7-13.3,11.2-29.5,17.8-47,17.8s-33.6-6.5-46.8-17.6c-79.3,47.3-69,81.7-69,81.7h.2v41.4h232.4v-43.6Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M128.3,448v-81.8c-19.6,5.7-39.6,4.8-58.7-.7v-30.5C-10,376.5.5,406.6.5,406.6v41.4h127.8Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M427.4,403.4c.5-12.5-7-51-103.6-100.5-41.4,30.4-97.7,30.5-139.1.3-96,49.3-103.5,87.7-103,100.2v44.6h346.5v-44.6h-.8Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipants);
export default __webpack_public_path__ + "static/media/participants.23d4853ba727b948955df0d62bcb9941.svg";
export { ForwardRef as ReactComponent };